<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin: 0 0 0 20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/examRecDetail',
         query: { id: $route.query.backId, name: $route.query.examName, num: $route.query.number }}">
          考试详情
        </el-breadcrumb-item>
        <el-breadcrumb-item>个人考试详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <div class="userEXamNameBox">
        考试人员：{{ $route.query.userName }}
      </div>
      <el-table :data="tableData"
        style="width: 100%;margin-top: 15px">
        <el-table-column prop="content" label="题目"></el-table-column>
        <el-table-column prop="options" label="选项">
          <template slot-scope="scope">
            <div v-if="scope.row.options">
              <span v-for="item in JSON.parse(scope.row.options)" :key="item.name">
                {{ item.name + '、' + item.value }}；
              </span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="isUploading" label="是否有图片" width="120px">
          <template slot-scope="{ row }">{{ row.isUploading === 0 ? '否' : '是' }}</template>
        </el-table-column> -->
        <el-table-column prop="isMuchChoice" label="类别" width="80px">
          <template slot-scope="{ row }">
            <span v-if="row.isMuchChoice === 1">单选</span>
            <span v-else-if="row.isMuchChoice === 0 ">判断</span>
            <span v-else>多选</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="分值" width="80px"></el-table-column>
        <el-table-column prop="correctAnswer" label="标准答案" width="100px"></el-table-column>
        <el-table-column prop="answer" label="考生答案" width="100px"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getUserExamDetail } from '@/api/processManager'
export default {
  name: 'userExamDetail',
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      getUserExamDetail(this.$route.query.id).then(res => {
        this.tableData = res.body.data
      })
    }
  }
}
</script>

<style scoped>
.userEXamNameBox {
  color: #F56C6C;
  font-size: 18px
}
</style>